import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

export const getEInvoicingBaseUrl = (organization?: Organization) =>
  getOrganizationViewUrl(organization?.url, reactRoute.organization.eInvoicing.getMainRoute())
